<template>
  <div style="display: none"></div>
</template>

<script>
import { createId } from "../utils/string";
import { positionValidator } from "../utils/vue";

export default {
  name: "external-object",
  props: {
    url: {
      type: String,
      required: true,
    },
    animation: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0, z: 0 }),
      validator: positionValidator,
    },
    rotation: {
      type: Object,
      validator: positionValidator,
      default: () => ({ x: 0, y: 0, z: 0 }),
    },
    scale: {
      type: Object,
      validator: positionValidator,
      default: () => ({ x: 1, y: 1, z: 1 }),
    },
  },
  data() {
    return {
      objName: null,
      id: null,
      instance: null,
    };
  },
  inject: {
    bimface: {
      default: {
        externalObjMng: null,
      },
    },
    model: {
      default: {
        model3D: null,
      },
    },
  },
  computed: {
    externalObjMng() {
      return this.bimface.externalObjMng;
    },
    model3D() {
      return this.model.model3D;
    },
  },
  watch: {
    "bimface.externalObjMng": function (newVal) {
      if (newVal) {
        this.init(newVal);
      }
    },
    position: function (newVal) {
      if (this.externalObjMng && this.id) {
        this.externalObjMng.translate(
          this.id,
          new THREE.Vector3(newVal.x, newVal.y, newVal.z)
        );
      }
    },
    animation: function (newVal) {
      if (this.externalObjMng && this.id) {
        if (newVal) {
          this.externalObjMng.play(this.id);
        } else {
          this.externalObjMng.pause(this.id);
        }
      }
    },
    scale: function (newVal) {
      if (this.externalObjMng && this.id) {
        this.externalObjMng.scale(this.id, newVal);
      }
    },
    rotation: function (newVal) {
      if (this.externalObjMng && this.id) {
        this.externalObjMng.rotate(this.id, newVal);
      }
    },
  },
  methods: {
    init(externalObjMng) {
      let name = createId();
      this.objName = name;
      externalObjMng.loadObject(
        {
          name,
          url: {
            objectUrl: this.url,
          },
        },
        () => {
          this.id = externalObjMng.getObjectIdByName(name);
          externalObjMng.translate(
            this.id,
            new THREE.Vector3(this.position.x, this.position.y, this.position.z)
          );
          this.animation && externalObjMng.play(this.id);
          this.scale !== 0 && externalObjMng.scale(this.id, this.scale);
          this.rotation && externalObjMng.rotate(this.id, this.rotation);
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
